export const ButtonShapes = {
  OVAL: 'oval',
  ROUND: 'round',
} as const;

export type ButtonShapes = (typeof ButtonShapes)[keyof typeof ButtonShapes];
